// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export const getPcnRenewalInitialState = () => ({
  // this is used to determine if we should allow the user to perform an action
  // on the highlighted paths. This is because we don't allow paths which are 'PCN Renewal In Progress'
  // to be updated but we allow the user to highlight them and generate reports for these paths
  // so if the user has highlighted paths which aren't 'PCN Renewal In Progress', then they can
  // perform an 'External Action' on them. Otherwise, they can only generate reports.
  allowExternalAction: false,

  // this is used to determine if the user has selected a PCN which is expired.
  // if true, this would prevent the user from performing 'Renew' and 'Filing' actions
  // in the UI.
  expiredPCNSelected: false,

  dataExpiration: null,
  data: [],
  highlightedPathIds: [],
  proposedPCNSelected: false,
  bulkReminderSummaryEmailData: [],
})

export const getPcnRenewalAdminTransactionsInitState = () => ({
  deletedPathSelected: false,
  nonDeletedPathSelected: false,
  // user cannot open update modal when canceledTransactionSelected is true.
  canceledTransactionSelected: false,

  // together with canceledTransactionSelected, nonCanceledTransactionSelected tells us if it's a combination of canceledStatuses are selected.
  // if both canceledTransactionSelected and nonCanceledTransactionSelected are true, we prevent users from using the cancel modal.
  nonCanceledTransactionSelected: false,

  // tracks if any paths with eligibility_status_cd is null
  eligibilityStatusNullSelected: false,

  // tracks if any expired path is selected.
  // this affects how the user can apply different transitions in the update modal.
  expiredTransactionSelected: false,

  // tracks internal status of selected paths.
  // different combination of selections determine what transition rules the user can apply.
  selectedInternalStatusIds: [],

  dataExpiration: null,
  data: [],
  highlightedTransactionIds: [],
})

export default {
  workOrders: {
    dataExpiration: null,
    data: [],
  },
  pcn: {
    dataExpiration: null,
    data: [],
  },
  filingStatus: {
    dataExpiration: null,
    data: [],
  },
  pcnRenewal: getPcnRenewalInitialState(),
  renewalAdmin: getPcnRenewalAdminTransactionsInitState(),
}
